import { Component, OnInit,Output,EventEmitter, Input, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

@Component({

    selector: 'aFormText,[aFormText]',
    templateUrl: './aFormText.component.html',
    styleUrls: ['./aFormText.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormTextComponent, multi: true },
    ]
})
export class AFormTextComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    value;
    _onChange = (value: any) => { };

    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this._onChange(value);
        this.value = value;
    }

    constructor(public rootService:RootService) { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormText/aFormText.component.ts